import Nav from './Components/Nav'
import {BrowserRouter,Routes,Route} from 'react-router-dom'
import Login from './Components/Login';
import appStyle from './App.css';
import Contactus from './Components/Contactus';
import Private from './Components/Private';
import SellProduct from './Components/SellProduct';
import Home from './Components/Home';
import Footer from './Components/Footer';
import Cycles from './Components/Cycles';
import Electronics from './Components/Electronics'
import Books from './Components/Books';
import All from './Components/All';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Nav/>
      <Routes>
      <Route path='/' element = {<Home/>}/>
      <Route element = {<Private/>}>
        <Route path='/buy' element = {<Home/>}/>
        <Route path='/sell' element = {<SellProduct/>}/>
        <Route path='/cycles' element = {<Cycles/>}/>
        <Route path='/electronics' element = {<Electronics/>}/>
        <Route path='/books' element = {<Books/>}/>
        <Route path='/allp' element = {<All/>}/>
      </Route>
      <Route path='/contactus' element = {<Contactus/>}/>
      <Route path='/signup' element = {<Login/>}/>
      </Routes>
      </BrowserRouter>
      <Footer/>
    </div>
  );
}

export default App;
